import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOT_MAIN_SECTION } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const MainSection = lazy(() => import('@/pages/mainSection'));
const TopBannerList = lazy(() => import('@/pages/mainSection/topBanner/TopBannerList'));
const NoticeList = lazy(() => import('@/pages/mainSection/notices/NoticeList'));

// 메인 섹션 라우트
export const mainSectionRoutes: TypedRouteObject = {
	path: ROOT_MAIN_SECTION,
	element: withSuspense(MainSection),
	handle: {
		title: '메인섹션 관리',
		subTitle: '락앤런 메인페이지 컨텐츠 관리'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		{
			path: paths.mainSection.topBanner.list,
			element: withSuspense(TopBannerList),
			handle: {
				title: '메인 최상단 배너 노출 관리',
				subTitle: '메인섹션 > 최상단 배너 > 최상단 배너 목록'
			}
		},
		{
			path: paths.mainSection.notice.list,
			element: withSuspense(NoticeList),
			handle: {
				title: '공지사항',
				subTitle: '락앤런 공지사항'
			}
		}
	]
};
